<template>
  <el-col class="chart-module" :lg="12" v-loading="loading">
    <div class="sub-view">
      <el-row>
        <span style="font-weight: bold">{{ displayTitle }}</span>
        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.onClose(title)"
        ></i>
        <i class="el-icon-zoom-in" v-else @click="showPopUp()"></i>
      </el-row>
      <el-row>
        <div style="float: right; padding: 0">
          <span style="padding: 0px 5px;">{{
            this.$root.htmlConst.cons_223_aggregate_period
          }}</span>
          <el-date-picker
              v-model="datePicker"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="〜"
              :picker-options="pickerOptions"
              @change="rebuildChart('main')"
              format="yyyy/MM/dd"
              value-format="yyyy-MM-dd"
              :clearable="false"
            >
          </el-date-picker>
        </div>
      </el-row>
      <hr />
      <el-row>
        <img @click="previousWeekDay()" src="../../assets/left_arrow.png" style="position: absolute;left: -1vh;top: 18vh;z-index:1;" />
        <img @click="nextWeekDay()" src="../../assets/right_arrow.png" style="position: absolute;right: 1vh;top: 18vh;z-index:1;"/>
        <echarts :autoresize="true" class="chart-view" :option="option" />
      </el-row>
      <el-dialog
        :visible.sync="popUpDisplay"
        :append-to-body="true"
        class="historyDailog"
      >
        <template slot="title">
          <el-row>
            <span style="font-weight: bold">{{ displayTitle }}</span>
          </el-row>
          <el-row>
            <div style="float: right; padding: 0">
              <span style="padding: 0px 5px;">{{
                this.$root.htmlConst.cons_223_aggregate_period
              }}</span>
              <el-date-picker
                  v-model="datePicker"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="〜"
                  :picker-options="pickerOptions"
                  @change="rebuildChart('main')"
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  :clearable="false"
                >
              </el-date-picker>
        </div>
      </el-row>
        </template>
        <hr />
        <div @click="previousWeekDay()">
          <img src="../../assets/left_arrow.png" style="position: absolute;left: 25px;top: 309px;z-index:1;width:50px;height:40px;" />
        </div>
        <echarts
          :autoresize="true"
          :option="option"
          style="height: 75vh"
          v-loading="popupLoading"
        />
        <div @click="nextWeekDay()">
          <img src="../../assets/right_arrow.png" style="position: absolute;left: 956px;top: 311px;z-index:1;width:50px;height:40px;"/>
        </div>
      </el-dialog>
    </div>
  </el-col>
</template>

<script>
import api from "@/api";
export default {
  name: "ChatbotSupportTicketTimeCountChart",
  props: ["title", "displayTitle"],
  data() {
    let _this = this;
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "Last Month",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Week",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24 * 7);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Day",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Day",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Week",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24 * 7);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24 * 7);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Month",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24 * 30);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24 * 30);

              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      datePicker: [this.$root.startDate, this.$root.endDate],
      option: this.option,
      loading: this.loading,
      popupLoading: this.popupLoading,
      popUpDisplay: false,
      currentWeekDay: this.currentWeekDay,
      weekDayRes: this.weekDayRes,
    };
  },
  mounted() {
    this.$bus.$on("changeEndMonth", (startDate, endDate) => {
      this.datePicker = [startDate, endDate];
      this.rebuildChart("main");
    });
  },
  created() {
    let self = this;
    self.loading = true;
    self.currentWeekDay = 1;
    api.getChatbotSupportTicketTimeCount(self.datePicker[0],self.datePicker[1]).then(
      (res) => {
        let weekDay;
        if (self.currentWeekDay == 1) {
          weekDay = "月曜日";
        } else if (self.currentWeekDay == 2) {
          weekDay = "火曜日";
        } else if (self.currentWeekDay == 3) {
          weekDay = "水曜日";
        } else if (self.currentWeekDay == 4) {
          weekDay = "木曜日";
        } else if (self.currentWeekDay == 5) {
          weekDay = "金曜日";
        } else if (self.currentWeekDay == 6) {
          weekDay = "土曜日";
        } else if (self.currentWeekDay == 7) {
          weekDay = "日曜日";
        }
        let data = res.data;
        self.weekDayRes = data;
        let data_list = [];
        let time_line = [];
        time_line.push(weekDay);
        // for (let i in data.output_list) {
          let obj = {
            title: {
              text: weekDay,
            },
            xAxis: [
              // {
              //   data: data.hour_list,
              // },
              {
                type: "category",
                name: "時",
                data: data.hour_list,
                splitLine: {
                  show: false,
                },
              },
            ],
            series: data.output_list[weekDay],
          };
          data_list.push(obj);
        // }
        self.option = {
          baseOption: {
            title: {
              right: "10%",
            },
            timeline: {
              show: false,
              axisType: "category",
              autoPlay: false,
              playInterval: 1000,
              data: time_line,
              label: {
                show: false,
                interval: 0,
                formatter: function (s) {
                  return s;
                },
              },
              padding: [10, -100],
            },
            tooltip: {
              formatter: function (params) {
                  return params.seriesName + "<br />"+ params.marker + params.name +"時 : " + params.value;
              },
            },
            calculable: true,
            barMaxWidth: "50%",
            grid: {
              top: 80,
              bottom: 80,
            },
            xAxis: [
              {
                type: "category",
                name: "時",
                data: data.hour_list,
                splitLine: {
                  show: false,
                },
              },
            ],

            yAxis: [
              {
                type: "value",
                name: "件数",
              },
            ],
            series: [
              {
                name: "件数",
                type: "bar",
              },
            ],
          },
          options: data_list,
        };
        self.loading = false;
      },
      (err) => {
        console.log(err);
      }
    );
  },
  methods: {
    previousWeekDay() {
      if (this.currentWeekDay == 1) {
        this.currentWeekDay = 7;
      } else {
        this.currentWeekDay--;
      }
      let weekDay;
      if (this.currentWeekDay == 1) {
        weekDay = "月曜日";
      } else if (this.currentWeekDay == 2) {
        weekDay = "火曜日";
      } else if (this.currentWeekDay == 3) {
        weekDay = "水曜日";
      } else if (this.currentWeekDay == 4) {
        weekDay = "木曜日";
      } else if (this.currentWeekDay == 5) {
        weekDay = "金曜日";
      } else if (this.currentWeekDay == 6) {
        weekDay = "土曜日";
      } else if (this.currentWeekDay == 7) {
        weekDay = "日曜日";
      }
      let data = this.weekDayRes;
      let data_list = [];
      let time_line = [];
      time_line.push(weekDay);
      // for (let i in data.output_list) {
        let obj = {
          title: {
            text: weekDay,
          },
          xAxis: [
            // {
            //   data: data.hour_list,
            // },
            {
              type: "category",
              name: "時",
              data: data.hour_list,
              splitLine: {
                show: false,
              },
            },
          ],
          series: data.output_list[weekDay],
        };
        data_list.push(obj);
      // }
      this.option = {
        baseOption: {
          title: {
            right: "10%",
          },
          timeline: {
            show: false,
            axisType: "category",
            autoPlay: false,
            playInterval: 1000,
            data: time_line,
            label: {
              show: false,
              interval: 0,
              formatter: function (s) {
                return s;
              },
            },
            padding: [10, -100],
          },
          tooltip: {
            formatter: function (params) {
                return params.seriesName + "<br />"+ params.marker + params.name +"時 : " + params.value;
            },
          },
          calculable: true,
          barMaxWidth: "50%",
          grid: {
            top: 80,
            bottom: 80,
          },
          xAxis: [
            {
              type: "category",
              name: "時",
              data: data.hour_list,
              splitLine: {
                show: false,
              },
            },
          ],

          yAxis: [
            {
              type: "value",
              name: "件数",
            },
          ],
          series: [
            {
              name: "件数",
              type: "bar",
            },
          ],
        },
        options: data_list,
      };
    },
    nextWeekDay() {
      if (this.currentWeekDay == 7) {
        this.currentWeekDay = 1;
      } else {
        this.currentWeekDay++;
      }
      let weekDay;
      if (this.currentWeekDay == 1) {
        weekDay = "月曜日";
      } else if (this.currentWeekDay == 2) {
        weekDay = "火曜日";
      } else if (this.currentWeekDay == 3) {
        weekDay = "水曜日";
      } else if (this.currentWeekDay == 4) {
        weekDay = "木曜日";
      } else if (this.currentWeekDay == 5) {
        weekDay = "金曜日";
      } else if (this.currentWeekDay == 6) {
        weekDay = "土曜日";
      } else if (this.currentWeekDay == 7) {
        weekDay = "日曜日";
      }
      let data = this.weekDayRes;
      let data_list = [];
      let time_line = [];
      time_line.push(weekDay);
      // for (let i in data.output_list) {
        let obj = {
          title: {
            text: weekDay,
          },
          xAxis: [
            // {
            //   data: data.hour_list,
            // },
            {
              type: "category",
              name: "時",
              data: data.hour_list,
              splitLine: {
                show: false,
              },
            },
          ],
          series: data.output_list[weekDay],
        };
        data_list.push(obj);
      // }
      this.option = {
        baseOption: {
          title: {
            right: "10%",
          },
          timeline: {
            show: false,
            axisType: "category",
            autoPlay: false,
            playInterval: 1000,
            data: time_line,
            label: {
              show: false,
              interval: 0,
              formatter: function (s) {
                return s;
              },
            },
            padding: [10, -100],
          },
          tooltip: {
            formatter: function (params) {
                return params.seriesName + "<br />"+ params.marker + params.name +"時 : " + params.value;
            },
          },
          calculable: true,
          barMaxWidth: "50%",
          grid: {
            top: 80,
            bottom: 80,
          },
          xAxis: [
            {
              type: "category",
              name: "時",
              data: data.hour_list,
              splitLine: {
                show: false,
              },
            },
          ],

          yAxis: [
            {
              type: "value",
              name: "件数",
            },
          ],
          series: [
            {
              name: "件数",
              type: "bar",
            },
          ],
        },
        options: data_list,
      };
    },
    showPopUp() {
      this.popUpDisplay = true;
    },
    rebuildChart(value) {
      let self = this;
      if (value == "main") {
        self.loading = true;
      } else {
        self.popupLoading = true;
      }

      api.getChatbotSupportTicketTimeCount(self.datePicker[0],self.datePicker[1]).then(
        (res) => {
          let weekDay;
          if (self.currentWeekDay == 1) {
            weekDay = "月曜日";
          } else if (self.currentWeekDay == 2) {
            weekDay = "火曜日";
          } else if (self.currentWeekDay == 3) {
            weekDay = "水曜日";
          } else if (self.currentWeekDay == 4) {
            weekDay = "木曜日";
          } else if (self.currentWeekDay == 5) {
            weekDay = "金曜日";
          } else if (self.currentWeekDay == 6) {
            weekDay = "土曜日";
          } else if (self.currentWeekDay == 7) {
            weekDay = "日曜日";
          }
          let data = res.data;
          self.weekDayRes = data;
          let data_list = [];
          let time_line = [];
          time_line.push(weekDay);
          // for (let i in data.output_list) {
            let obj = {
              title: {
                text: weekDay,
              },
              xAxis: [
                // {
                //   data: data.hour_list,
                // },
                {
                  type: "category",
                  name: "時",
                  data: data.hour_list,
                  splitLine: {
                    show: false,
                  },
                },
              ],
              series: data.output_list[weekDay],
            };
            data_list.push(obj);
          // }
          self.option = {
            baseOption: {
              title: {
                right: "10%",
              },
              timeline: {
                show: false,
                axisType: "category",
                autoPlay: false,
                playInterval: 1000,
                data: time_line,
                label: {
                  show: false,
                  interval: 0,
                  formatter: function (s) {
                    return s;
                  },
                },
                padding: [10, -100],
              },
              tooltip: {
                formatter: function (params) {
                    return params.seriesName + "<br />"+ params.marker + params.name +"時 : " + params.value;
                },
              },
              calculable: true,
              barMaxWidth: "50%",
              grid: {
                top: 80,
                bottom: 80,
              },
              xAxis: [
                {
                  type: "category",
                  name: "時",
                  data: data.hour_list,
                  splitLine: {
                    show: false,
                  },
                },
              ],

              yAxis: [
                {
                  type: "value",
                  name: "件数",
                },
              ],
              series: [
                {
                  name: "件数",
                  type: "bar",
                },
              ],
            },
            options: data_list,
          };
          if (value == "main") {
            self.loading = false;
          } else {
            self.popupLoading = false;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>
<style>
</style>
